/**
 * Service catalog translations
 */
export const serviceCatalog = {
  en: {
    title: "Service Catalog",
    subtitle: "Manage services, pricing tiers, and bundles",
    bundles: "Bundles",
    addService: "Add Service",
    totalServices: "Total Services",
    active: "Active",
    totalTiers: "Total Tiers",
    featuredTiers: "Featured Tiers",
    searchServices: "Search services...",
    showInactive: "Show inactive",
    services: "Services",
    loadingServices: "Loading services...",
    noServicesFound: "No services found matching your criteria.",
    noDescription: "No description",
    tiers: "tiers",
    editService: "Edit Service",
    openTier: "Open",
    costModel: "Cost model",
    manageDeliverables: "Manage Deliverables",
    duplicate: "Duplicate",
    activate: "Activate",
    deactivate: "Deactivate",
    deleteService: "Delete Service",
    pricingTiers: "Pricing Tiers",
    addTier: "Add Tier",
    noTiersConfigured: "No tiers configured for this service",
    tier: "Tier",
    price: "Price",
    timeline: "Timeline",
    deliverables: "Deliverables",
    actions: "Actions",
    deliverablesPreview: "Deliverables Preview:",
    moreItems: "more...",
    noDeliverablesConfigured: "No deliverables configured",
    items: "items",
    inactive: "Inactive",
    addServiceTitle: "Add Service",
    addServiceDesc: "Create a new service category. You can add pricing tiers after creating the service.",
    code: "Code",
    icon: "Icon",
    nameEnglish: "Name (English)",
    nameSpanish: "Name (Spanish)",
    descriptionEnglish: "Description (English)",
    descriptionSpanish: "Description (Spanish)",
    activeVisible: "Active (visible on website)",
    createService: "Create Service",
    deleteServiceTitle: "Delete Service",
    deleteServiceDesc: "Are you sure you want to delete this service? This will also delete all associated pricing tiers. This action cannot be undone.",
    // Service detail page
    serviceNotFound: "Service not found",
    failedToLoadService: "Failed to load service",
    backToCatalog: "Back to Catalog",
    editServiceDetailsAndTiers: "Edit service details and pricing tiers",
    serviceDetails: "Basic information about this service",
    processStages: "Process Stages",
    processStagesDesc: "Define the stages displayed in the service workflow indicator",
    addStage: "Add Stage",
    noStagesDefined: 'No stages defined. Click "Add Stage" to create process stages.',
    nameEn: "Name (EN)",
    nameEs: "Name (ES)",
    shortLabel: "Short (e.g. D)",
    definePricingOptions: "Define pricing options for this service",
    noTiersConfiguredClick: 'No pricing tiers configured. Click "Add Tier" to create one.',
    addPricingTier: "Add Pricing Tier",
    createTierForService: "Create a new pricing tier for",
    starterCode: "STARTER",
    featuredTier: "Featured tier",
    starterNameEn: "Starter Package",
    starterNameEs: "Paquete Inicial",
    priceDisplay: "Price Display",
    priceDisplayExample: "$2,500 - $5,000",
    priceNumeric: "Price (number)",
    priceNumericHint: "Numeric price used for margin calculation",
    priceUnit: "Price Unit",
    priceUnitExample: "/month",
    timelineEnglish: "Timeline (English)",
    timelineEnExample: "2-3 weeks",
    timelineSpanish: "Timeline (Spanish)",
    timelineEsExample: "2-3 semanas",
    deliverablesInTier: "Deliverables Included in This Tier",
    noDeliverablesYet: "No deliverables defined yet. Add deliverables first.",
    selectDeliverables: "Select which deliverables are included in this tier. Manage deliverables",
    here: "here",
    createTier: "Create Tier",
    deleteTier: "Delete Tier",
    deleteTierConfirm: "Are you sure you want to delete",
    noPriceSet: "No price set",
    featured: "Featured",
    saveTier: "Save Tier",
    // Deliverables page
    deliverablesTitle: "Deliverables",
    deliverablesSubtitle: "Manage deliverables with phase and tier associations",
    serviceSettings: "Service Settings",
    addDeliverable: "Add Deliverable",
    totalDeliverables: "Total Deliverables",
    totalDays: "Total Days",
    phases: "Phases",
    filterByTier: "Filter by Tier",
    allTiers: "All tiers",
    generalDeliverables: "General Deliverables",
    noPhaseAssigned: "Sin fase asignada",
    days: "days",
    noDeliverablesForPhase: "No deliverables for this phase yet.",
    addDeliverableTitle: "Add Deliverable",
    addDeliverableDesc: "Add a new deliverable to this service. Assign to phases and tiers.",
    phaseOptional: "Phase (Optional)",
    noPhaseGeneral: "No phase (general)",
    nameEnRequired: "Name (English) *",
    nameEnPlaceholder: "e.g., Brand Audit",
    nameEsLabel: "Name (Spanish)",
    nameEsPlaceholder: "e.g., Auditoría de Marca",
    estimatedDays: "Estimated Days",
    includeInTiers: "Include in Tiers",
    editDeliverable: "Edit Deliverable",
    editDeliverableDesc: "Update the deliverable details and tier associations.",
    deleteDeliverable: "Delete Deliverable",
    deleteDeliverableConfirm: "Are you sure you want to delete",
    saveChanges: "Save Changes",
    // Workflow phases page
    workflowPhases: "Workflow Phases",
    workflowPhasesDesc: "Manage the 5 universal phases used across all services",
    phaseDefinitions: "Phase Definitions",
    phaseDefinitionsDesc: "These 5 phases are applied consistently across all services. Each service has specific deliverables mapped to these phases.",
    order: "Order",
    phase: "Phase",
    color: "Color",
    editPhase: "Edit Phase",
    editPhaseDesc: "Update the phase details. Changes will apply across all services.",
    descEnglish: "Description (English)",
    descSpanish: "Description (Spanish)",
    iconPlaceholder: "Search, Lightbulb, etc.",
    // Tier item composition (billable pass-through — TKT-2026-1704)
    itemsSection: "Items",
    addItem: "Add Item",
    itemName: "Item Name",
    itemType: "Type",
    typeFixed: "Fixed",
    typeRange: "Range",
    typeQuantity: "Quantity",
    rangeMin: "Min",
    rangeMax: "Max",
    unitPrice: "Unit Price",
    defaultQty: "Default Qty",
    clientPaysDefault: "Client pays by default?",
    deleteItem: "Delete Item",
    deleteItemConfirm: "Are you sure you want to delete",
    noItemsYet: "No items yet. Add the sub-items this tier is composed of.",
    newItemDefault: "New item",
    cancel: "Cancel",
    itemSaved: "Item saved",
    itemDeleted: "Item deleted",
    itemError: "Could not save item",
  },
  es: {
    title: "Catálogo de Servicios",
    subtitle: "Gestionar servicios, niveles de precios y paquetes",
    bundles: "Paquetes",
    addService: "Agregar Servicio",
    totalServices: "Total Servicios",
    active: "Activos",
    totalTiers: "Total Niveles",
    featuredTiers: "Niveles Destacados",
    searchServices: "Buscar servicios...",
    showInactive: "Mostrar inactivos",
    services: "Servicios",
    loadingServices: "Cargando servicios...",
    noServicesFound: "No se encontraron servicios con los criterios indicados.",
    noDescription: "Sin descripción",
    tiers: "niveles",
    editService: "Editar Servicio",
    openTier: "Abrir",
    costModel: "Modelo de costo",
    manageDeliverables: "Gestionar Entregables",
    duplicate: "Duplicar",
    activate: "Activar",
    deactivate: "Desactivar",
    deleteService: "Eliminar Servicio",
    pricingTiers: "Niveles de Precio",
    addTier: "Agregar Nivel",
    noTiersConfigured: "No hay niveles configurados para este servicio",
    tier: "Nivel",
    price: "Precio",
    timeline: "Tiempo",
    deliverables: "Entregables",
    actions: "Acciones",
    deliverablesPreview: "Vista previa de entregables:",
    moreItems: "más...",
    noDeliverablesConfigured: "Sin entregables configurados",
    items: "elementos",
    inactive: "Inactivo",
    addServiceTitle: "Agregar Servicio",
    addServiceDesc: "Crear una nueva categoría de servicio. Puedes agregar niveles de precio después de crear el servicio.",
    code: "Código",
    icon: "Icono",
    nameEnglish: "Nombre (Inglés)",
    nameSpanish: "Nombre (Español)",
    descriptionEnglish: "Descripción (Inglés)",
    descriptionSpanish: "Descripción (Español)",
    activeVisible: "Activo (visible en el sitio web)",
    createService: "Crear Servicio",
    deleteServiceTitle: "Eliminar Servicio",
    deleteServiceDesc: "¿Estás seguro de que deseas eliminar este servicio? Esto también eliminará todos los niveles de precio asociados. Esta acción no se puede deshacer.",
    // Service detail page
    serviceNotFound: "Servicio no encontrado",
    failedToLoadService: "Error al cargar el servicio",
    backToCatalog: "Volver al Catálogo",
    editServiceDetailsAndTiers: "Editar detalles del servicio y niveles de precio",
    serviceDetails: "Información básica sobre este servicio",
    processStages: "Etapas del Proceso",
    processStagesDesc: "Define las etapas que se muestran en el indicador de flujo del servicio",
    addStage: "Agregar Etapa",
    noStagesDefined: 'Sin etapas definidas. Haz clic en "Agregar Etapa" para crear etapas del proceso.',
    nameEn: "Nombre (EN)",
    nameEs: "Nombre (ES)",
    shortLabel: "Corto (ej. D)",
    definePricingOptions: "Define opciones de precio para este servicio",
    noTiersConfiguredClick: 'Sin niveles de precio configurados. Haz clic en "Agregar Nivel" para crear uno.',
    addPricingTier: "Agregar Nivel de Precio",
    createTierForService: "Crear un nuevo nivel de precio para",
    starterCode: "INICIAL",
    featuredTier: "Nivel destacado",
    starterNameEn: "Starter Package",
    starterNameEs: "Paquete Inicial",
    priceDisplay: "Precio Visible",
    priceDisplayExample: "$2,500 - $5,000",
    priceNumeric: "Precio (número)",
    priceNumericHint: "Precio numérico usado para el cálculo de margen",
    priceUnit: "Unidad de Precio",
    priceUnitExample: "/mes",
    timelineEnglish: "Tiempo (Inglés)",
    timelineEnExample: "2-3 weeks",
    timelineSpanish: "Tiempo (Español)",
    timelineEsExample: "2-3 semanas",
    deliverablesInTier: "Entregables Incluidos en Este Nivel",
    noDeliverablesYet: "Sin entregables definidos aún. Agrega entregables primero.",
    selectDeliverables: "Selecciona qué entregables están incluidos en este nivel. Gestionar entregables",
    here: "aquí",
    createTier: "Crear Nivel",
    deleteTier: "Eliminar Nivel",
    deleteTierConfirm: "¿Estás seguro de que deseas eliminar",
    noPriceSet: "Sin precio establecido",
    featured: "Destacado",
    saveTier: "Guardar Nivel",
    // Deliverables page
    deliverablesTitle: "Entregables",
    deliverablesSubtitle: "Gestionar entregables con asociaciones de fase y nivel",
    serviceSettings: "Configuración del Servicio",
    addDeliverable: "Agregar Entregable",
    totalDeliverables: "Total Entregables",
    totalDays: "Días Totales",
    phases: "Fases",
    filterByTier: "Filtrar por Nivel",
    allTiers: "Todos los niveles",
    generalDeliverables: "Entregables Generales",
    noPhaseAssigned: "Sin fase asignada",
    days: "días",
    noDeliverablesForPhase: "Sin entregables para esta fase aún.",
    addDeliverableTitle: "Agregar Entregable",
    addDeliverableDesc: "Agrega un nuevo entregable a este servicio. Asigna a fases y niveles.",
    phaseOptional: "Fase (Opcional)",
    noPhaseGeneral: "Sin fase (general)",
    nameEnRequired: "Nombre (Inglés) *",
    nameEnPlaceholder: "ej., Auditoría de Marca",
    nameEsLabel: "Nombre (Español)",
    nameEsPlaceholder: "ej., Auditoría de Marca",
    estimatedDays: "Días Estimados",
    includeInTiers: "Incluir en Niveles",
    editDeliverable: "Editar Entregable",
    editDeliverableDesc: "Actualiza los detalles del entregable y asociaciones de nivel.",
    deleteDeliverable: "Eliminar Entregable",
    deleteDeliverableConfirm: "¿Estás seguro de que deseas eliminar",
    saveChanges: "Guardar Cambios",
    // Workflow phases page
    workflowPhases: "Fases del Flujo de Trabajo",
    workflowPhasesDesc: "Gestiona las 5 fases universales usadas en todos los servicios",
    phaseDefinitions: "Definiciones de Fases",
    phaseDefinitionsDesc: "Estas 5 fases se aplican consistentemente en todos los servicios. Cada servicio tiene entregables específicos mapeados a estas fases.",
    order: "Orden",
    phase: "Fase",
    color: "Color",
    editPhase: "Editar Fase",
    editPhaseDesc: "Actualiza los detalles de la fase. Los cambios se aplicarán en todos los servicios.",
    descEnglish: "Descripción (Inglés)",
    descSpanish: "Descripción (Español)",
    iconPlaceholder: "Search, Lightbulb, etc.",
    // Tier item composition (billable pass-through — TKT-2026-1704)
    itemsSection: "Elementos",
    addItem: "Agregar Elemento",
    itemName: "Nombre del Elemento",
    itemType: "Tipo",
    typeFixed: "Fijo",
    typeRange: "Rango",
    typeQuantity: "Cantidad",
    rangeMin: "Mín",
    rangeMax: "Máx",
    unitPrice: "Precio Unitario",
    defaultQty: "Cant. por Defecto",
    clientPaysDefault: "¿El cliente paga por defecto?",
    deleteItem: "Eliminar Elemento",
    deleteItemConfirm: "¿Estás seguro de que deseas eliminar",
    noItemsYet: "Sin elementos aún. Agrega los sub-elementos que componen este nivel.",
    newItemDefault: "Nuevo elemento",
    cancel: "Cancelar",
    itemSaved: "Elemento guardado",
    itemDeleted: "Elemento eliminado",
    itemError: "No se pudo guardar el elemento",
  },
};
